module.exports = __webpack_public_path__ + "static/media/flecha_volver.c1cadbba.svg";